import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import {
  getCallPassAPIInfos,
  upsertCallPassAPIInfo,
} from "../services/callpassService";
import { decrypt } from "../utils/aesGcm";
import type { ReqUpsertCallPassAPIInfo } from "../types/callpass.types";

export const useCallPassAPIInfos = (companyGuid: string | null) =>
  useQuery({
    queryKey: ["callpassAPIInfos", companyGuid],
    queryFn: () => getCallPassAPIInfos(companyGuid!),
    enabled: !!companyGuid,
    gcTime: 0,
  });

export const useDecryptedApiInfo = (
  companyGuid: string,
  encryptedApiInfo: string | undefined,
) =>
  useQuery({
    queryKey: ["callpassDecrypted", companyGuid, encryptedApiInfo],
    queryFn: async () => {
      const json = await decrypt(companyGuid, encryptedApiInfo!);
      return JSON.parse(json) as Record<string, string>;
    },
    enabled: !!encryptedApiInfo,
    gcTime: 0,
    retry: false,
  });

export const useUpsertCallPassAPIInfo = (companyGuid: string) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (req: ReqUpsertCallPassAPIInfo) => upsertCallPassAPIInfo(req),
    onSuccess: () => {
      toast.success("API 설정이 저장되었습니다.");
      qc.invalidateQueries({ queryKey: ["callpassAPIInfos", companyGuid] });
    },
    onError: (err: Error) => {
      toast.error(`저장 실패: ${err.message}`);
    },
  });
};
